module.exports = __webpack_public_path__ + "img/kv.bc38b941.png";